module.exports = __webpack_public_path__ + "f74a6db4ddb41a1480d7ed129f976ae0.png";